<template>
  <div class="TA-drill-through-main">
    <!-- Top bar showing filter selections -->
    <div class="filtered-section" id="filtered-section">
      <!-- first column -->
      <div class="filtered-items">
        <div class="info-row">
          <div class="filter-title-long">Selected Date Range</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">{{ startDate }} to {{ endDate }}</div>
        </div>

        <div class="info-row">
          <div class="filter-title-long">Destination</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">{{ selectedDestination}}</div>
        </div>
      </div>

      <div class="refresh-section">
        <div>Last Refreshed : {{ refreshDate }}</div>
      </div>
    </div>
    
    <div class="drill-through-body" id="drill-through-body">
      <TableBox
        :hideColumns="['#']"
        :tableData="tableData"
        :title="tableTitle"
        :loading="tableLoading"
      />
    </div>

    <Loader :loadingText="loadText" :isVisbile.sync="loading" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
       //top bar section
      startDate: "",
      endDate: "",
      refreshDate: "",
      selectedDestination: "",

      //table section
      tableData: [],

    };
  },
  props: {},
  methods: {
    getDataFromStorage: async function() {
      var details = JSON.parse(
        sessionStorage.getItem(this.$route.params.drillThroughName)
      );
      this.startDate = details.startdate;
      this.endDate = details.enddate;
      this.refreshDate = details.refreshdate;
      this.selectedDestination = details.destcode ? details.destcode : 'All' ;
      this.tableTitle = `${details.title}`;
      this.createDrillThrough(details);
    },
    createDrillThrough: async function(d) {
      let dataToPost = {
        startdate : d.startdate,
        enddate : d.enddate,
        rpttype : d.rpttype,
        // destination : this.selectedDestination.length > 0 ? this.selectedDestinationPost.toString() : null,
        destcode : d.destcode,
      }
      if(d.rpttype == 'By_TAdrillthrough'){
        this.tableData = await this.$apiCallV2(
          "/TurnaroundAnalysis/GetTurnaroundAnalysis",
          dataToPost
        );
      }
    },
  },
  async mounted() {
    this.$fullscreenLoading("Getting Drillthrough Details");
    this.getDataFromStorage();
    this.$fullscreenLoading();
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.TA-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;
  /* display: flex; */

  > .filtered-section {
    width: 100%;
    height: 80px;
    background-color: white;
    display: flex;
    align-items: center;
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* position: relative; */

    > .filtered-items {
      width: 100%;
      height: auto;
      align-items: center;
      // display: flex;
      //justify-content: space-between; */

      .info-row {
        display: flex;
        align-items: center;
        > .filter-title-long {
          width: 270px;
          padding: 3px;
          padding-left: 3px;
        }
        > .filter-title {
          width: 120px;
          padding-left: 3px;
        }
        > .colon-separator {
          margin: 0 5px;
        }
        > .filter-details {
          width: 100%;
        }
      }
    }

    > .refresh-section {
       height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        white-space: nowrap;
        margin-right: 3px;
    }
  }

  > .drill-through-body {
    width: 100%;
    height: calc(100% - 90px);
    background-color: white;
    border-radius: 5px;
    padding: 5px;
  }
}
</style>